import _ from 'lodash';
import {createAction, createReducer} from 'redux-act';
import {baseUrl} from '../scripts/env';
import axios from 'axios'
import l8n from 'l8n';

const REDUCER = 'jivo_widget';
const NS = `@@${REDUCER}/`;

const initialState = {
  settings: {
    isLoading: false,
    payload: {
      code_host: null,
      public_id: null
    }
  }
};

export const fetchSettingsRequest = createAction(`${NS}FETCH_WIDGET_SETTINGS_REQUEST`);
export const fetchSettingsSuccess = createAction(`${NS}FETCH_WIDGET_SETTINGS_SUCCESS`);
export const fetchSettingsFailure = createAction(`${NS}FETCH_WIDGET_SETTINGS_FAILURE`);
export const fetchSettings = () => async dispatch => {
  dispatch(fetchSettingsRequest);

  const {data} = await axios({url: `${baseUrl}/widget/${l8n.locale}/settings`});
  const settings = _.pick(data, _.keys(initialState.settings.payload));

  if (_.isEmpty(settings)) {
    dispatch(fetchSettingsFailure());
    return false;
  }

  dispatch(fetchSettingsSuccess(settings));
  return true;
};

export default createReducer({
    [fetchSettingsRequest]: state => ({...state, settings: {...state.settings, isLoading: true}}),
    [fetchSettingsSuccess]: (state, payload) => ({...state, settings: {payload, isLoading: true}}),
    [fetchSettingsFailure]: state => ({...state, settings: {...state.settings, isLoading: true}}),
  },
  initialState
);


// WEBPACK FOOTER //
// ./src/ducks/jivo_widget.js